<template>
    <v-main style="overflow-y: hidden; overflow-x: hidden;">
        <v-overlay :value="loading">
            <v-sheet justify-center align-center outlined color="transparent">
                <v-progress-circular indeterminate :size="50">
                </v-progress-circular> </v-sheet
        ></v-overlay>
        <v-fade-transition>
                <v-row no-gutters class="alert-badge" v-if="alert.value">
                    <v-alert :type="alert.status">
                        <span v-text="alert.text"></span>
                    </v-alert>
                </v-row>
        </v-fade-transition>
        <v-row>
            <v-col cols="12" class="px-8 py-10 relative-container">
                <v-row>
                    <v-col cols="8" sm="8" md="8">
                        <QualifiedForm
                            @onSelectSection="onSelectSection"
                            @loadingUpdate="loadingProcess"
                        />
                    </v-col>
                    <v-col cols="4" sm="4" md="4">
                        <QualifiedGuide />
                    </v-col>
                    <v-col cols="12" md="12" class="mb-10">
                        <QualifiedList
                            :studentDataBack="data_student_sent"
                            :acceptForm="acceptForm"
                            :validateData="validateData"
                            :registerFormId="registerFormId"
                            :registerPlan="registerPlan"
                            :semesterYear="semesterYear"
                            :toggleUpdateStudent="toggleUpdateStudent"
                            :student_id_pattern="student_id_pattern"
                            :trigger_student_id_pattern="
                                trigger_student_id_pattern
                            "
                            @getListValidate="getListValidate"
                            @onClickGenerate="onClickGenerate"
                            @getSelectedStudents="getSelectedStudents"
                            @fakeUpdateSelected="fakeUpdateSelected"
                            @loadingUpdate="loadingProcess"
                            id="row-overflow"
                        />
                    </v-col>
                    <v-col cols="12" md="12" v-if="acceptForm" style="overflow-y: hidden;">
                        <v-row
                            class="my-0 d-flex justify-end"
                            style="
                                position: fixed;
                                top: 90%;
                                right: 1%;
                                background-color: #ffffff;
                                width: 100%;
                                height: 100px;
                            "
                        >
                            <v-col
                                cols="12"
                                md="6"
                                class="mt-4 mb-1 d-flex column justify-end"
                            >
                                <v-btn
                                    class="prompt-title-page"
                                    color="#FF9800"
                                    rounded
                                    dark
                                    outlined
                                    width="240"
                                    height="40"
                                    style="
                                        font-size: 18px;
                                        box-shadow: 0px 0px 20px rgba(255, 152, 0, 0.2);
                                    "
                                    @click="onClickDecline"
                                    >{{ $t('message.qualifiedApplicants.cancel') }}</v-btn
                                >
                                <v-btn
                                    class="prompt-title-page btn__overlay ml-5"
                                    color="#FF9800"
                                    rounded
                                    width="240"
                                    height="40"
                                    style="
                                        font-size: 18px;
                                    "
                                    :disabled="tempSelected.length == 0"
                                    @click="onClickAccept"
                                    >{{ $t('message.qualifiedApplicants.transfer') }}</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <QualifiedDialog
            :dialogBool="dialog"
            @updateListId="updateListId"
            @toggleFetchStudent="toggleFetchStudent"
        />
        <AcceptDialog
            :Bool="moveDialog"
            :transferNumber="selected.length"
            @submitTransfer="submitTransfer"
        />
    </v-main>
</template>

<script>
import QualifiedForm from "@/components/admin/Candidates/Qualified/QualifiedForm.vue";
import QualifiedList from "@/components/admin/Candidates/Qualified/QualifiedList.vue";
import QualifiedGuide from "@/components/admin/Candidates/Qualified/QualifiedGuide.vue";
import QualifiedDialog from "./Qualified/QualifiedDialog.vue";
import AcceptDialog from "./Qualified/AcceptDialog.vue";
import * as services from "@/services";

export default {
    components: {
        QualifiedForm,
        QualifiedList,
        QualifiedGuide,
        QualifiedDialog,
        AcceptDialog,
    },
    data() {
        return {
            registerFormId: null,
            registerFormDetail: null,
            registerPlan: [],
            semesterYear: null,
            startSemesterDate: null,
            data_student_sent: [],
            data_student: [],
            data_selected: [],
            stringBuffer: "",
            dialog: false,
            moveDialog: false,
            acceptForm: false,
            form: false,
            validateData: false,
            loading: 0,
            students: [],
            selected: [],
            tempSelected: [],
            toggleUpdateStudent: false,
            student_id_pattern: null,
            trigger_student_id_pattern: false,

            alert: {
                value: false,
                text: "",
                status: "",
            },
        };
    },
    methods: {
        onSelectSection(value) {
            // update init fetch students data
            this.registerFormId = value?.registerFormId;
            this.semesterYear = value?.semesterYear;
            this.startSemesterDate = value?.startSemesterDate;
            this.acceptForm = true;
        },
        onClickDecline() {
            // close step 3
            this.acceptForm = false;
        },
        onClickGenerate(state = false) {
            // open generate student id popup
            this.dialog = state;
        },
        onClickAccept() {
            // submit transfer student
            this.changeCommand();
        },
        toggleFetchStudent() {
            // fetch selected students
            this.toggleUpdateStudent = !this.toggleUpdateStudent;
        },
        fakeUpdateSelected(selected){
            // update temp selected students
            this.tempSelected = selected
        },
        getSelectedStudents(selected, students) {
            // update students data
            this.students = students;
            this.selected = selected
        },
        submitTransfer() {
            // prepare transfer students
            const student_transfer = [];
            for (let i = 0; i < this.students.length; i++) {
                for (let j = 0; j < this.selected.length; j++) {
                    if (this.students[i].id == this.selected[j].id) {
                        student_transfer.push(this.students[i]);
                    }
                }
            }
            this.sendTransferData(this.selected);
        },
        async sendTransferData(student_transfer) {
            // transfer students to core
            try {
                this.loadingProcess(1);
                const body = {
                    students: student_transfer,
                    academicYear: this.semesterYear,
                };
                let res = await services.studentTransfer(body)
                res = res?.data?.data?.infos
                const errorRes = res.filter((item) => item?.res?.status == "errors" || item?.res?.status == "error")
                if(errorRes.length == 0){
                    this.showAlert("success", `${this.$i18n.t('message.qualifiedApplicants.sheet.transferred')}: ${student_transfer.length} ${this.$i18n.t('message.qualifiedApplicants.error.case')}`);
                }
                else if(errorRes.length == student_transfer.length){
                    this.showAlert("error", `${this.$i18n.t('message.qualifiedApplicants.error.transferFail')}`);
                }
                else{
                    this.showAlert("error", `${this.$i18n.t('message.qualifiedApplicants.error.failToTransfer')} : ${errorRes.length} ${this.$i18n.t('message.qualifiedApplicants.error.case')}`);
                }
                setTimeout(() => {
                    // update after submit
                    this.reQueryStudent()
                }, 1000);
            } finally{
                this.loadingProcess(-1);
            }
        },
        reQueryStudent(){
            // re query student
            this.acceptForm = false;
            setTimeout(() => {
            this.onSelectSection({
                    registerFormId: this.registerFormId,
                    semesterYear: this.semesterYear,
                    startSemesterDate: this.startSemesterDate
                })
            }, 1000);
        },
        updateListId(array) {
            this.student_id_pattern = array;
            this.trigger_student_id_pattern = !this.trigger_student_id_pattern;
        },
        addZero(num, digitNumber) {
            let txtVal = "";
            let zeroTxt = "";
            let newDigit = digitNumber.toString().length - 1;
            if (num.toString().length == newDigit) {
                txtVal = num.toString();
            } else {
                for (
                    let digitCount = num.toString().length;
                    digitCount < newDigit;
                    digitCount++
                ) {
                    zeroTxt = zeroTxt + "0";
                }
                txtVal = zeroTxt + num.toString();
            }
            return txtVal;
        },
        showAlert(status, text) {
            this.alert.value = true;
            this.alert.text = text;
            this.alert.status = status;
            setTimeout(() => {
                this.closeAlert();
            }, 3000);
        },
        closeAlert() {
            this.alert.value = false;
        },
        loadingProcess(value) {
            if (value == 0) {
                this.loading = 0;
            }
            this.loading += value;
            if (this.loading < 0) this.loading = 0;
        },
        changeCommand() {
            this.validateData = !this.validateData;
            this.toggleFetchStudent();
        },
        getListValidate(value) {
            // validate student data
            this.form = value;
            if (this.form) {
                this.moveDialog = !this.moveDialog;
            }
        },
        async fetchRegisterForm() {
            try {
                this.loadingProcess(1);
                let res = await services.getRegistrationFormById(
                    this.registerFormId
                );
                this.registerFormDetail = res.data.data.registration_form;
                this.registerPlan = [];
                this.registerFormDetail.register_plans.map((plan) => {
                    this.registerPlan.push(plan);
                });
            } finally {
                this.loadingProcess(-1);
            }
        },
    },
    watch: {
        registerFormId() {
            this.fetchRegisterForm();
        },
    },
};
</script>

<style scoped>

.alert-badge {
    z-index: 10;
    position: fixed;
    right: 0;
    bottom: 0;
    margin: 10px;
}
.btn__overlay{
    color: white !important;
    box-shadow: 0px 0px 20px rgba(255, 152, 0, 0.2);
}
.btn__overlay:disabled{
    color: white !important;
    box-shadow: 0px 0px 20px transparent;
}
</style>